// extracted by mini-css-extract-plugin
module.exports = {"root":"Datepicker_root__36Kl2","datepickerWrapper":"Datepicker_datepickerWrapper__Yh4WI","icon":"Datepicker_icon__2m3O6"};